export enum LOCALE {
    BG = 'bg',
    EN = 'en',
}
